import axios from 'axios'

/* Types */
import {
  RequestBody,
  SuggestionAddress,
} from '@/types/api/dadata/suggestionAddress'

const dadataApi = {
  url: null as null | string,
  config: {},
  init(url: string, apiKey: string) {
    this.url = url
    this.config = {
      headers: {
        authorization: `Token ${apiKey}`,
      },
    }
    return this
  },
  async getSuggestions(
    query: string,
    option?: {
      count?: number
      locations_boost?: string
      from_bound?: string
      bound?: string
    },
  ) {
    try {
      const body: RequestBody = {
        query,
        locations: [
          {
            country: '*',
          },
        ],
      }

      if (option) {
        if (option.count) body.count = option.count
        if (option.locations_boost)
          body.locations_boost = option.locations_boost
        if (option.from_bound) body.from_bound = option.from_bound
        if (option.bound) body.bound = option.bound
      }

      const result = await axios.post<SuggestionAddress>(
        `${this.url}suggest/address`,
        body,
        this.config,
      )
      return result.data.suggestions
    } catch (error) {
      if (error.response?.status) {
        switch (error.response.status) {
          case 400:
            throw new Error(`Некорректный запрос (невалидный JSON или XML)`)
          case 401:
            throw new Error(`В запросе отсутствует API-ключ`)
          case 403:
            throw new Error(`В запросе указан несуществующий API-ключ...`)
          case 405:
            throw new Error(`Запрос сделан с методом, отличным от POST`)
          case 413:
            throw new Error(
              `Слишком большая длина запроса или слишком много условий`,
            )
          case 429:
            throw new Error(`Слишком много запросов в секунду`)
          case error.response.status > 500:
            throw new Error(`Произошла внутренняя ошибка сервиса`)
          default:
            throw new Error(`Произошла ошибка с кодом ${error.response.status}`)
        }
      }
      throw error
    }
  },
}
export default dadataApi
